import React from "react";
import LegalPage, { LegalBackButton } from "./legal/LegalPage";
import { CMS_SLUGS } from "./legal/cmsContent";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      slug={CMS_SLUGS.PRIVACY_POLICY}
      title="Privacy Policy"
      subtitle="How Nyawoo collects, uses and protects your information."
      cardLabel="Nyawoo privacy policy"
      renderActions={() => <LegalBackButton />}
    />
  );
}
